import type { HTMLAttributes, ReactNode } from "react";
import clsx from "clsx";

export interface CardProps extends Omit<HTMLAttributes<HTMLElement>, "title"> {
  title?: ReactNode;
  description?: ReactNode;
  actions?: ReactNode;
  bodyClassName?: string;
}

export function Card({
  title,
  description,
  actions,
  className,
  bodyClassName,
  children,
  ...rest
}: CardProps) {
  return (
    <section className={clsx("eh-card min-w-0 max-w-full", className)} {...rest}>
      {(title || actions || description) && (
        <header className="flex flex-wrap items-start justify-between gap-3 border-b border-separator px-5 py-4">
          <div className="min-w-0 flex-1">
            {title && (
              <h2 className="text-base font-semibold text-label break-words">{title}</h2>
            )}
            {description && (
              <p className="mt-1 text-sm text-label-secondary">{description}</p>
            )}
          </div>
          {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
        </header>
      )}
      <div className={clsx("min-w-0 px-5 py-4", bodyClassName)}>{children}</div>
    </section>
  );
}
